<div class="row">
  <div class="col-6">
    <div class="card">
      <div class="card-header">

        <!-- Title -->
        <h4 class="card-header-title">
          <i class="fas fa-edit"></i> Questionnaires à remplir
        </h4>

      </div>
      <div class="card-body p-0">

        <!-- List group -->
        <div class="list-group list-group-flush">
          @for (questionnaire of availableQuestionnaires | async; track questionnaire) {
            <div>
              @if (questionnaire.status !== 'FINALIZED') {
                <a
                  [routerLink]="'/questionnaires/' + questionnaire.keyname + '/' + questionnaire.id"
                  class="list-group-item form-to-fill p-4">
                  <app-dashboard-questionnaire [questionnaire]="questionnaire"
                  [showShowAccessQuestionnaireButton]="true"></app-dashboard-questionnaire>
                </a>
              }
              @if (questionnaire.status == 'FINALIZED') {
                <div
                  class="list-group-item form-to-fill p-4">
                  <app-dashboard-questionnaire [questionnaire]="questionnaire"
                  [showShowAccessQuestionnaireButton]="false"></app-dashboard-questionnaire>
                </div>
              }
            </div>
          }

          @if (availableQuestionnairesStatus === 'NO_FORMS_AVAILABLE') {
            <div
              class="list-group-item form-to-fill p-4">
              Vous n'avez aucun questionnaire à remplir.
            </div>
          }
          @if (availableQuestionnairesStatus === 'LOADING') {
            <div
              class="list-group-item form-to-fill p-4">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Chargement des questionnaires...</span>
              </div>
              Chargement des questionnaires...
            </div>
          }
        </div>

      </div>
    </div>
  </div>
  @if (isFileUploadFlagActive) {
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">
            <i class="fas fa-folder"></i> Vos fichiers
          </h4>
          <a class="btn btn-sm btn-white" href="#!">
            <i class="fas fa-upload"></i> Téléverser
          </a>
        </div>
        <div class="card-body">
          <!-- List group -->
          <div class="list-group list-group-flush my-n3">
            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Avatar -->
                  <a class="avatar" href="#!">
                    <i class="fas fa-3x fa-file-pdf"></i>
                  </a>
                </div>
                <div class="col ms-n2">
                  <!-- Title -->
                  <h4 class="mb-1">
                    <a href="#!">Déclaration d'impôt de l'année précédente</a>
                  </h4>
                  <!-- Time -->
                  <p class="card-text small text-muted">
                    2.5kb SVG
                  </p>
                </div>
                <div class="col-auto">
                  <!-- Dropdown -->
                  <div class="dropdown">
                    <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                      data-bs-toggle="dropdown" href="#" role="button">
                      <i class="fe fe-more-vertical"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a class="dropdown-item" href="#!">
                        Action
                      </a>
                      <a class="dropdown-item" href="#!">
                        Another action
                      </a>
                      <a class="dropdown-item" href="#!">
                        Something else here
                      </a>
                    </div>
                  </div>
                </div>
              </div> <!-- / .row -->
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
